import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import * as FreudDS from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { OfficeModalModule } from '@office-ui/modal/modal.module';
import { NgxMaskModule } from 'ngx-mask';
import { TooltipModule } from 'primeng/tooltip';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';
import { SharedModule } from 'shared/shared.module';

import { PromptuaryFormCrmModule } from './components/promptuary-form/crm/promptuary-form-crm.module';
import { PromptuaryFormModule } from './components/promptuary-form/default/promptuary-form.module';
import { PromptuaryPage } from './components/promptuary-page/promptuary-page.component';
import { PromptuaryReasonsModule } from './components/promptuary-reasons/promptuary-reasons.module';
import { PromptuaryViewModule } from './components/promptuary-view/promptuary-view.module';
import { PromptuaryRoutes } from './promptuary.routes';

@NgModule({
	declarations: [PromptuaryPage],
	imports: [
		CommonModule,
		FormsModule,
		FreudDS.FreudAutoCompleteModule,
		FreudDS.FreudButtonModule,
		FreudDS.FreudDialogModule,
		FreudDS.FreudInputTextModule,
		FreudDS.FreudLoaderModule,
		FreudDS.FreudRadioButtonModule,
		FreudDS.FreudSelectModule,
		NgxMaskModule.forChild(),
		OfficeModalModule,
		RouterModule.forChild(PromptuaryRoutes),
		SharedModule,
		TooltipModule,
		TranslateModule.forChild(),
		PromptuaryReasonsModule,
		PromptuaryFormCrmModule,
		PromptuaryFormModule,
		PromptuaryViewModule,
	],
	providers: [PromptuaryService],
})
export class PromptuaryModule {}
